import { css } from '@emotion/react';
import { theme } from '../../../domain/theme';
import { contentPackageMediumStyle } from '../ContentPackage/style/contentPackageMediumStyle';

export const videoItemStyle = bgColor => {
  const mediumStyle = contentPackageMediumStyle(bgColor);

  return {
    container: [
      mediumStyle.container,
      css`
        ${theme.mq.tablet} {
          margin: 0 0 0 24px;
        }
      `
    ],
    image: {
      container: mediumStyle.image.container,
      picture: mediumStyle.image.picture,
      cta: [
        mediumStyle.image.cta,
        css`
          width: 32px;
          height: 32px;
          ${theme.mq.tablet} {
            width: 56px;
            height: 56px;
          }
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          svg {
            width: 24px;
            height: 24px;
            ${theme.mq.tablet} {
              width: 40px;
              height: 40px;
            }
          }
        `
      ]
    },
    text: {
      container: [
        mediumStyle.text.container,
        css`
          padding: 0 24px;
          ${theme.mq.tablet} {
            padding: 0;
          }
        `
      ],
      sponsored: mediumStyle.text.sponsored,
      taxonomy: mediumStyle.text.taxonomy,
      title: mediumStyle.text.title,
      subtitle: [
        mediumStyle.text.subtitle,
        css`
          -webkit-line-clamp: 5;
          ${theme.mq.tablet} {
            -webkit-line-clamp: 2;
          }
        `
      ],
      cta: mediumStyle.text.cta
    }
  };
};
